// DuplicatePairList (Domain/Customers, BL-189; was history/DuplicatePairs.tsx's list): the office's
// possible duplicates (BL-029), pairs of customers that share a phone, an email or a service address,
// for those who can merge. Each pair on a hairline: what they share, muted, then both customers as
// underlined words (buttons), each opening that record (where "Merge into another…" is). A pair that
// really is two people (a tenant, a new owner) is just left. The words come ready to show ("Same phone
// number and address").
// The page folds it in an Area, closed until asked for. Reads only --duppairs-*; Link reads its own.
import type { ReactNode } from 'react';
import { Link } from '../Link/Link.tsx';
import './DuplicatePairList.css';

export interface DuplicatePair {
  /** The two customers, as ids ("a:b"). */
  key: string;
  /** What they share, in words: "Same phone number and address". */
  same: string;
  people: readonly { id: string; name: string; number: string }[];
}

export interface DuplicatePairListProps {
  pairs: readonly DuplicatePair[];
  /** Opens a customer's record. */
  onOpen: (id: string) => void;
  /** A muted line before the pairs: what the list is and what to do with it. */
  note?: ReactNode;
}

export function DuplicatePairList({ pairs, onOpen, note }: DuplicatePairListProps) {
  return (
    <div className="fl-duppairs">
      {note ? <p className="fl-duppairs__note">{note}</p> : null}
      <ul className="fl-duppairs__list">
        {pairs.map((p) => (
          <li key={p.key} className="fl-duppairs__pair">
            <span className="fl-duppairs__same">{p.same}</span>
            <span className="fl-duppairs__who">
              {p.people.map((c) => (
                <Link key={c.id} size="touch-on-phone" onPress={() => onOpen(c.id)}>
                  {/* one inline run, so the touch-on-phone flex Link keeps the space before the number */}
                  <span>
                    {c.name} <span className="fl-duppairs__num">{c.number}</span>
                  </span>
                </Link>
              ))}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
